module.exports = __webpack_public_path__ + "img/logo.3d7af5c3.png";